var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrongRelation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#000",
    d: "m3.86238,60l74.13762,-57.93079l74.13762,57.93079l-74.13762,57.93079l-74.13762,-57.93079z",
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 0 0)",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Noto Sans JP",
    fontSize: 24,
    strokeWidth: 0,
    id: "svg_6",
    y: 68.93098,
    x: 37,
    stroke: "#000",
    fill: "#000000",
    fontWeight: "normal",
    fontStyle: "normal"
  }, "Relation"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrongRelation);
export default __webpack_public_path__ + "static/media/StrongRelation.c3eb52823b20bd5e073b1568ba3626b0.svg";
export { ForwardRef as ReactComponent };